import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../BasePanelPage";
import {PaymentSucceededIcon} from "../../../../../SVGElements";
import {Messages} from "../../../../../Messages";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {collapseIframe} from "../../../../../widget/misc/WidgetUtils";
import {Perk} from "../../subscribe/components/CoverageDescriptionElements";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {DonationSuccessPanelStyle} from "../DonationSuccessPanel";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {iFrameState} from "../../../../../services/IFrameState";


@registerStyle(DonationSuccessPanelStyle)
export class EditDonationSuccessPanel extends BasePanelPage {
    getEditDonationMessage() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        return Messages.editDonationSuccessText1(donation.formatPrice());
    }

    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return []
        }

        return [
            <Perk text={Messages.editDonationSuccessGuideline1}/>,
            <Perk text={Messages.editDonationSuccessGuideline2}/>,
        ];
    }

    render() {
        const {styleSheet} = this;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null : <PaymentSucceededIcon className={styleSheet.icon}/>,
            <div testId="editDonationModalThankYouTitle" className={styleSheet.title}>{Messages.editDonationSuccessTitle}</div>,
            <MessageElement testId="editDonationModalThankYouMessage1" className={styleSheet.message} message={this.getEditDonationMessage()}/>,
            <div testId="editDonationModalThankYouMessage2" className={styleSheet.message}>{Messages.editDonationSuccessText2}</div>,
            this.getGuidelines(),
            <MerchantButton className={styleSheet.button} onClick={collapseIframe}>
                {Messages.ok}
            </MerchantButton>,
        ];
    }
}
